import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./Config/ProtrectedRoute";
import ContractSearch from "./pages/ContractSearch";
import CompareContracts from "./pages/CompareContracts";
import Copilot from "./pages/Copilot";
import Reports from "./pages/Reports";
import Login from "./pages/Login";
import AgentChat from "./pages/AgentChat";

// Main App component that sets up the router and routes
// It includes protected routes for authenticated users and redirects for unauthenticated users
function App() {

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="/ContractSearch" replace />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/ContractSearch"
            element={
              <ProtectedRoute>
              <ContractSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/compare-contracts"
            element={
              <ProtectedRoute>
              <CompareContracts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/copilot"
            element={
              <ProtectedRoute>
              <Copilot />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
              <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chatbot"
            element={
              <ProtectedRoute>
              <AgentChat />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;